module.exports = __webpack_public_path__ + "img/数据交换select.4d051fa1.svg";